import {
  AnswerType,
  Fnol,
  FnolTemplate,
  InsuranceHolder,
  InsuredObject,
} from '../types/types';
import { axiosInstance } from './api';

const fnolServices = {
  initiate: async function (fnolTemplateName: string): Promise<Fnol> {
    const body = {
      fnolTemplateName,
    };

    return axiosInstance.post('Fnol/Init', body);
  },
  complete: async function (
    fnolKey: string,
    email: string,
    phoneNumber: string
  ): Promise<void> {
    const body = {
      fnolKey,
      email,
      phoneNumber,
    };

    return axiosInstance.post('Fnol/Complete', body);
  },
  getFnol: async function (fnolKey: string): Promise<Fnol> {
    return axiosInstance.get('Fnol/Get', { params: { fnolKey } });
  },
  getFnolTemplates: async function (): Promise<FnolTemplate[]> {
    return axiosInstance.get('Fnol/GetReports');
  },
  setVar: async function (
    fnolKey: string,
    questionKey: string,
    tag: AnswerType,
    contents: string
  ): Promise<Fnol> {
    const body = {
      var: {
        tag,
        contents,
      },
      fnolKey,
      questionKey,
    };

    return axiosInstance.post('Fnol/SetVar', body);
  },
  setInsuredObject: async function (
    fnolKey: string,
    insuredObject: InsuredObject
  ) {
    const body = {
      fnolKey,
      ...insuredObject,
    };

    return axiosInstance.post('Fnol/SetInsuredObject', body);
  },
  setInsuranceHolder: async function (
    fnolKey: string,
    insuranceHolder: InsuranceHolder
  ) {
    const body = {
      fnolKey,
      ...insuranceHolder,
    };

    return axiosInstance.post('Fnol/SetInsuranceHolder', body);
  },
  setIncidentDay: async function (
    fnolKey: string,
    incidentDay: string
  ): Promise<Fnol> {
    const body = {
      fnolKey,
      incidentDay,
    };

    return axiosInstance.post('Fnol/SetIncidentDay', body);
  },
  setCustomerEmail: async function (fnolKey: string, email: string) {
    const body = {
      fnolKey,
      email,
    };

    return axiosInstance.post('Fnol/SetCustomEmail', body);
  },
  setCustomerTelephoneNumber: async function (
    fnolKey: string,
    phoneNumber: string
  ) {
    const body = {
      fnolKey,
      phoneNumber,
    };

    return axiosInstance.post('Fnol/SetCustomPhoneNumber', body);
  },
  addAttachment: async function (
    fnolKey: string,
    fileName: string,
    fileUrl: string
  ): Promise<Fnol> {
    const body = {
      fnolKey,
      fileName,
      fileUrl,
    };

    return axiosInstance.post('Fnol/AddAttachment', body);
  },
  removeAttachment: async function (
    fnolKey: string,
    fileName: string
  ): Promise<Fnol> {
    const body = {
      fnolKey,
      fileName,
    };

    return axiosInstance.post('Fnol/RemoveAttachment', body);
  },
  getPresignedS3Url: async function (fileName: string) {
    const body = {
      fileName,
    };

    return await axiosInstance.post('S3Presign/GetPresignUrl', body);
  },
};

export default fnolServices;
